;(function ($, window, document, undefined) {
    'use strict';

    var Users = function (element, options) {
        this.opts      = options;
        this.els       = options.els;
        this.init();
    };

    Users.prototype = {

        init : function () {
            this.header();
        },

        header : function () {
            var $page = $('#page-content')
            var $head = $('#user-profile-ranking-wrap');
            var $div = $('<div />');

            if (!$head.size()) {
                return;
            }

            $div.load('/t5/custom/page/page-id/xhr-requests?sceeajax=true&r=ranking&i=' + LITHIUM.CommunityJsonObject.Page.object.id + ' #response', function () {
                var data = $(this).find('#ranking').data();
                var $info = $page.find('.info-text');

                $page.addClass('status-ready').find('.ui-loader-horizontal').removeClass('visible');

                if (data.level) {
                    $head.find('.user-medal').removeClass('level-3').addClass('level-'+data.level);
                    $head.find('.number').text(data.levelFormat);
                    $head.find('.progress span').css('width', data.progress);
                    $head.find('label span').text(data.name);
                    $head.find('.percentage').text(data.progress);
                } else {
                    $('#user-profile-ranking').hide();
                }

                $info.find('h1 span').text(LITHIUM.CommunityJsonObject.Page.object.login);
                $info.prepend('<div class="avatar"><img src="' + data.userAvatar + '" /></div>');

                if (data.admin || data.special) {
                    var rank = data.name;
                    if (data.special) {
                        rank = data.specialRank;
                    }
                    $info.append('<span class="role role-' + rank.toLowerCase().replace(/\s/g, '-') + '">' + rank + '</span>');
                }

                if (data.online) {
                    $info.append('<span class="online user-status">' + pageData.localisation.online + '</span>');
                } else {
                    $info.append('<span class="offline user-status">' + pageData.localisation.offline + '</span>');
                }
            } );
        }
    };

    $.fn.Users = function (options){

        var args     = Array.prototype.slice.call(arguments, 1),
            $item    = $(this),
            instance = $item.data( 'Users' );

        if (!instance) {
            instance = new Users(this, options);
            $item.data('Users', instance);
        }

        if (typeof options === 'string') {
            instance[options].apply(instance, args);
        }

        return this;
    };

})(jQuery, window, document);
